import axios, { AxiosResponse } from "axios";
import { TableData } from "../../models/dtos/base/TableData";
import { CreateFlashCardDTO } from "../../models/dtos/content/leitner/CreateFlashCardDTO";
import { FlashCardsDTO } from "../../models/dtos/content/leitner/FlashCardsDTO";
import { QueryPagesDTO } from "../../models/query-strings/base/QueryPagesDTO";
import BaseService from "../base/BaseService";

export default class FlashCardService extends BaseService {
    create(createFlashCardDTO: CreateFlashCardDTO): Promise<any> {
        return axios.post(`/FlashCardStudent`, createFlashCardDTO)
            .then(function (response: AxiosResponse<any, any>) {
                return response.data;
            });
    }

    getPaged(boxId: string, query: QueryPagesDTO): Promise<TableData<FlashCardsDTO>> {
        return axios.get(`/FlashCardStudent/${boxId}`, { params: query })
            .then(function (response: AxiosResponse<TableData<FlashCardsDTO>, any>) {
                return response.data;
            });
    }
    delete(boxId: string): Promise<any> {
        return axios.delete(`/FlashCardStudent/${boxId}`).then(function (response: any) { return response.data;});
    }
}